// AboutUs.js
import React from 'react';
import Footer from './components/Footer';
import Header from './components/Header';

const AboutUs = () => {
  return (
    <div>
      <Header />
      <h1>Privacy</h1>
      <p>Welcome to our application. Here’s what we do...</p>
      <Footer />
    </div>
  );
};

export default AboutUs;
